/**
 * @ngdoc directive
 * @name ng.directive:ngFollow
 * @element ANY
 */

const ngFollow = [function () {
    return {
        link: function ( $scope, $item, $params ) {
            if ( 'ontouchstart' in document.documentElement ) {
                let timeout = 0;
                $item[0].addEventListener('touchstart', (e) => {
                    timeout = setTimeout(() => {
                        window.location = atob($params.ngFollow);
                    }, 200);
                }, {passive: true});
                $item[0].addEventListener('touchmove', () => {
                    clearTimeout(timeout);
                }, {passive: true});
            } else {
                $item[0].addEventListener('click', (e) => {
                    window.location = atob($params.ngFollow);
                });
                if ( $item[0].tagName.toLowerCase() === 'a') {
                    $item[0].addEventListener('mouseover', (e) => {
                        $item[0].href = atob($params.ngFollow);
                    }, {passive: true});
                    $item[0].addEventListener('mouseout', (e) => {
                        $item[0].removeAttribute("href");
                    }, {passive: true});
                }
            }

        }
    }
}];

export default ngFollow;
